var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRrp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.38 343.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.56,216.01c-11.42.01-21.27,6.92-25.52,16.63-4.76,10.87-2.32,22.85,5.91,31.36l-24.28,24.47c-11.01,11.09-10.31,28.48.4,39.51l15.5,15.96H43.96C19.74,343.96,0,324.46,0,300.13V43.84C0,19.94,19.28.14,43.2.11l116.48-.11-.05,75.17c-.02,24.22,18.14,43.61,42.35,44.82l77.44.02.03,74.54c-8.56-3.45-17.52-3.66-26.07,1.28-6.65,3.84-12.22,11.06-13.62,20.16l-28.19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.41,96.03c-12.13.1-21.01-9.1-20.8-20.84l.14-67.94,88.48,88.66-67.82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.59,260l3.53-3.97-50.61-.06c-6.68,0-11.75-5.47-11.92-11.62-.18-6.55,4.95-12.32,11.92-12.33l50.61-.06-3.7-4.2c-4.31-4.89-3.75-12.19.86-16.52,4.36-4.09,11.68-4.53,16.36.1l23.24,23c5.97,5.91,5.97,13.39,0,19.31l-22.83,22.65c-4.67,4.63-11.69,4.83-16.39.8-4.93-4.23-5.78-11.81-1.1-17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217,320.06l3.24,3.67c4.32,4.9,4.31,11.87.03,16.43s-12.07,5.29-16.9.49l-22.89-22.76c-2.94-2.92-4.96-5.83-5-9.79s1.93-6.97,4.88-9.91l22.88-22.78c4.8-4.78,12.45-4.34,16.82.17,4.81,4.96,4.57,12.65-.69,17.49-.7.64-1.42,1.65-2.19,2.85l50.45.09c6.59.01,11.52,5.49,11.75,11.51.24,6.37-4.78,12.39-11.67,12.41l-50.71.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrp);
export default __webpack_public_path__ + "static/media/rrp.fb565ac0e6ee84a35e96e14b870a684c.svg";
export { ForwardRef as ReactComponent };